import { useLogout } from 'Shared/hooks/api';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Analytics, inquiryKakao } from 'Shared/utils/client';
import type { StyledButtonProps } from '@viewup/ui';
import { Button, Column } from '@viewup/ui';
import { useGlobalModalStore } from 'app/_hook';

const helpAndLogoutStyle: StyledButtonProps = {
  size: 'M',
  styledComponents: {
    root: {
      color: 'text.tertiary',
      justifyContent: 'flex-start',
      width: '100%',
    },
  },
  variant: 'ghost.assistive',
};

export const HelpAndLogout = () => {
  const { accessToken } = useTokenStore();
  const { getValue } = useGlobalModalStore();
  const { setAlertModal, setConfirmModal } = getValue('actions');
  const { logout } = useLogout({
    options: {
      onSuccess: () => {
        Analytics.getInstance().track('LOGOUT_SUCCESS');
        setAlertModal({
          content: '로그아웃 되었어요.',
          exitHandler: () => window.location.reload(),
          hasCloseButton: false,
          onClickButton: () => window.location.reload(),
        });
      },
    },
  });

  return (
    <Column bgColor='system.white' gap={8} p={16}>
      <Button
        {...helpAndLogoutStyle}
        onClick={() => {
          Analytics.getInstance().track('MY_VIEWUP_KAKAO_INQUIRY');
          inquiryKakao();
        }}
      >
        1:1 문의하기
      </Button>
      {accessToken && (
        <Button
          {...helpAndLogoutStyle}
          onClick={() =>
            setConfirmModal({
              content: '로그아웃 할까요?',
              fillButtonText: '확인',
              hasCloseButton: false,
              onClickFillButton: () => logout({}),
              outlineButtonText: '취소',
              styledComponents: {
                fillButton: {
                  size: 'L',
                },
                outlineButton: {
                  size: 'L',
                },
              },
            })
          }
        >
          로그아웃
        </Button>
      )}
    </Column>
  );
};
